"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType[UserType["NotSpecified"] = 0] = "NotSpecified";
    UserType[UserType["Customer"] = 1] = "Customer";
    UserType[UserType["Employee"] = 2] = "Employee";
    UserType[UserType["Anonymous"] = 3] = "Anonymous";
    UserType[UserType["Terminal"] = 4] = "Terminal";
    UserType[UserType["System"] = 5] = "System";
    UserType[UserType["Pos"] = 6] = "Pos";
    UserType[UserType["External"] = 7] = "External";
    UserType[UserType["PosAnonymous"] = 8] = "PosAnonymous";
})(UserType = exports.UserType || (exports.UserType = {}));
